import { Divider, Upload } from 'antd';
import Papa from 'papaparse';
import { FiFilePlus } from '@react-icons/all-files/fi/FiFilePlus';
import { IoMdLink } from '@react-icons/all-files/io/IoMdLink';
import { FiDownload } from '@react-icons/all-files/fi/FiDownload';
import { postRequest } from '../../../../../../services/requestService';
import { showErrorToast } from '../../../../../../services/notificationsService';
import { ZorbaButton } from '../../../../../../components/forms';
import { BULK_SUBMIT_VALIDATE_DATA } from '../../constants';
import Spinner from '../../../../../../components/layout/Spinner';

import './index.scss';

const requiredColumns = [
  'ASKING PRICE',
  'BATHS',
  'BEDS',
  'PROPERTY ADDRESS',
  'YEAR BUILT',
];

export const SelectSource = ({
  setWizardStep,
  setData,
  isLoading,
  setIsLoading,
  setDuplicatesCounter,
}) => {
  const beforeUpload = (file) => {
    const isCSV = file.type === 'text/csv';
    if (!isCSV) {
      showErrorToast('You can only upload CSV files!');
    }
    return isCSV || Upload.LIST_IGNORE;
  };

  const handleUpload = ({ file }) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const csvText = e.target.result;
      setIsLoading(true);

      Papa.parse(csvText, {
        header: true,
        skipEmptyLines: true,
        complete: async (result) => {
          if (result.data.length === 0) {
            showErrorToast('Empty CSV file!');
            setIsLoading(false);
            return;
          }
          if (result.data.length > 100) {
            showErrorToast('CSV file exceeds the maximum limit of 100 rows!');
            setIsLoading(false);
            return;
          }
          const csvHeaders = result?.meta?.fields || [];
          const missingColumns = requiredColumns.filter(
            (col) => !csvHeaders.includes(col),
          );

          if (missingColumns.length) {
            showErrorToast(
              `Missing required columns: ${missingColumns.join(
                ', ',
              )}. Please download a valid template and start over.`,
            );
            setIsLoading(false);
            return;
          }

          try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append(
              'data',
              JSON.stringify(
                result.data.map((data) => ({
                  ...data,
                  'ASKING PRICE': data['ASKING PRICE']
                    ? data['ASKING PRICE'].replace(/[$,]/g, '')
                    : data['ASKING PRICE'],
                })),
              ),
            );
            const response = await postRequest(
              '/pre-deal/bulk-validate',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
                timeout: 120000, // 2minutes
              },
            );
            setData(response?.data?.data || []);
            setDuplicatesCounter(response?.data?.duplicatesCounter);
            setWizardStep(BULK_SUBMIT_VALIDATE_DATA);
            setIsLoading(false);
          } catch (error) {
            setIsLoading(false);
            showErrorToast('Uploading CSV file failed! Please try again!');
          }
        },
        error: () => {
          setIsLoading(false);
          showErrorToast('CSV Parsing Failed! Please try again!');
        },
      });
    };
    reader.readAsText(file);
  };

  return (
    <div className="select-source">
      <div className="title-container">
        <span className="title">Submit Leads</span>
        <span className="description">
          {`Access early buyer demand and save time on deals you’re still working
          on with Zorba Pro.`}
        </span>
      </div>
      <div className="cards-container">
        {isLoading ? (
          <div className="spinner-container">
            <Spinner />
          </div>
        ) : (
          <>
            <div className="source-card active">
              <div className="icon-container">
                <FiFilePlus size={35} className="card-icon active" />
              </div>
              <span className="card-title active">Import CSV</span>
              <span className="card-description active">
                You can import up to 100 unique properties at a time.
              </span>
              <Upload
                beforeUpload={beforeUpload}
                showUploadList={false}
                customRequest={({ file }) => handleUpload({ file })}
              >
                <ZorbaButton fullWidth>Select CSV file</ZorbaButton>
              </Upload>
              <Divider className="divider" />
              <a
                href="https://zorba.s3.us-east-1.amazonaws.com/partners/bulk_input_example.csv"
                download
                className="download-link"
              >
                <FiDownload className="download-icon" />
                Download sample template
              </a>
            </div>
            <div className="source-card">
              <div className="icon-container">
                <IoMdLink size={35} className="card-icon" />
              </div>
              <span className="card-title">Integrate Podio</span>
              <span className="card-description">Coming soon</span>
              <ZorbaButton disabled>Link Podio</ZorbaButton>
            </div>
            <div className="source-card">
              <div className="icon-container">
                <IoMdLink size={35} className="card-icon" />
              </div>
              <span className="card-title">Integrate Salesforce</span>
              <span className="card-description">Coming soon</span>
              <ZorbaButton disabled>Link Salesforce</ZorbaButton>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
